
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class CounterOrdersDialog extends Serenity.EntityDialog<CounterOrdersRow, any> {
        protected getFormKey() { return CounterOrdersForm.formKey; }
        protected getIdProperty() { return CounterOrdersRow.idProperty; }
        protected getLocalTextPrefix() { return CounterOrdersRow.localTextPrefix; }
        protected getNameProperty() { return CounterOrdersRow.nameProperty; }
        protected getService() { return CounterOrdersService.baseUrl; }
        protected getDeletePermission() { return CounterOrdersRow.deletePermission; }
        protected getInsertPermission() { return CounterOrdersRow.insertPermission; }
        protected getUpdatePermission() { return CounterOrdersRow.updatePermission; }

        protected form = new CounterOrdersForm(this.idPrefix);

        protected updateInterface(): void {

            super.updateInterface();

            if (this.isNew() == false) {
                // finding all editor elements and setting their readonly attribute
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);

                // remove required asterisk (*)
                //this.domNode.querySelectorAll('sup').forEach(el => el.style.display = 'none');

                // here is a way to locate a button by its css class
                // note that this method is not available in 
                // getToolbarButtons() because buttons are not 
                // created there yet!
                // 
                // this.toolbar.findButton('delete-button').hide();

                // entity dialog also has reference variables to
                // its default buttons, lets use them to hide delete button
                this.deleteButton.hide();

                // we could also hide save buttons just like delete button,
                // but they are null now as we removed them in getToolbarButtons()
                // if we didn't we could write like this:
                //
                // this.applyChangesButton.hide();
                // this.saveAndCloseButton.hide();

                // instead of hiding, we could disable a button
                //
                // this.deleteButton.toggleClass('disabled', true);
            }
        }


        loadEntity(entity: OrdersRow) {
            super.loadEntity(entity);
            //debugger;


            this.form.CustomerId.change(e => {
                var vcustomerId = this.form.CustomerId.value;

                if (Q.isEmptyOrNull(vcustomerId)) {
                    // this.setProductDetails({});

                }
                else {

                    try {

                        Orders.OrdersService.GetDetail({
                            CustomerId: parseInt(vcustomerId)
                            //      
                        }, response => {
                            this.form.CustomerId.value = this.form.CustomerId.value;
                            this.form.CustomerName1.value = response.CustomerName;
                            this.form.CustomerMobile11.value = response.CustomerMobile1;
                            this.form.CustomerMobile21.value = response.CustomerMobile2;
                            this.form.CustomerEmail1.value = response.CustomerEmail1;
                            this.form.CustomerEmail2.value = response.CustomerEmail2;
                            this.form.Gstin.value = response.GSTIN;



                            this.form.BillingAddress1.value = response.BillingAddress1;
                            this.form.BillingAddress2.value = response.BillingAddress2;
                            this.form.BillingCity.value = response.BillingCity;
                            this.form.BillingStateId.value = response.BillingState.toString();
                            this.form.Gstin.value = response.BillingGSTIN;
                            this.form.BillingPincode.value = Number(response.BillingPincode);
                        });


                    }
                    catch (e) {

                    }


                }

            });



            this.form.OrderProductSpecificationId.change(e => {
                var OrderProductSpecificationId = this.form.OrderProductSpecificationId.value;

               
                if (Q.isEmptyOrNull(OrderProductSpecificationId)) {

                    this.form.OrderProductSpecificationId.value = "";
                    this.form.GrossAmount.value = null;
                    this.form.NetAmount.value = null;
                    this.form.TaxableAmount.value = null;
                    this.form.TaxAmount.value = null;

                }
                else {
                    if (Q.isEmptyOrNull(this.form.CustomerId.value)) {
                        Q.notifyError("Please Select Customer first");
                        this.form.OrderProductSpecificationId.value = null;
                        return
                    }
                    if (Q.isEmptyOrNull(this.form.BillingStateId.value)) {
                        Q.notifyError("Please Select Billing State first");
                        this.form.OrderProductSpecificationId.value = null;
                        return
                    }
                    if (Q.isEmptyOrNull(this.form.ProductId.value)) {
                        Q.notifyError("Please Select Billing State first");
                        this.form.OrderProductSpecificationId.value = null;
                        return
                    }
                    var ent = this.get_entity();
                    var ent1 = this.getSaveEntity();
                    
                    if (this.form.ProductId && this.form.OrderProductSpecificationId) {
                        Orders.CounterOrdersService.CreateCounterOrder({
                            Entity: ent1
                        }, response => {
                            this.form.GrossAmount.value = response.Entity.GrossAmount;
                            this.form.NetAmount.value = response.Entity.GrossAmount;
                            this.form.TaxableAmount.value = response.Entity.GrossAmount;
                            this.form.TaxAmount.value = response.Entity.GrossAmount;
                            this.form.ProductId.value = response.Entity.ProductId.toString();
                            this.form.OrderProductSpecificationId.value = response.Entity.OrderProductSpecificationId.toString();
                            var dlg = new CounterOrdersDialog();
                            dlg.loadByIdAndOpenDialog(response.Entity.Id);
                            this.dialogClose();

                            

                        });
                    }

                }




                });


            }
    }
  }
